import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import MaritalKeys from "helper/constant/maritalKeys";
import ErrorMessages from "helper/errorMessages";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import moment from "moment";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import { InputNumber } from "primereact/inputnumber";

function AddTeachers() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [teacherHeading, setTeacherHeading] = useState(
    CommonHeadings.teacherAddHeading
  );
  const [dateOfBirth, setDateOfBirth] = useState(null); // only use in the primereact calendar when we select the birth date
  const [joiningdate, setJoiningdate] = useState(null); // only use in the primereact calendar when we select the joining date
  const dropdownValues = [
    MaritalKeys.single,
    MaritalKeys.married,
    MaritalKeys.divorced,
    MaritalKeys.widowed,
  ]; // in this file , we just define the marital keys\
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [teachersID, setTeachersID] = useState();

  const [teachers, setTeachers] = useState({
    name: "",
    dob: "",
    dob_num: null,
    selected_marital_status: "",
    address: "",
    contact_no: "",
    whatsapp_no: null,
    pan_number: "",
    email: "",
    department: "",
    designation: "",
    joining_date: "",
    joining_date_num: null,
    salary: null,
    salary_num: null,
    father_husband_name: "",
    father_husband_no: null,
    account_no: "",
    bank_name: "",
    bank_code: "",
    account_holder_name: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    selected_marital_status: "",
    contact_no: "",
    joining_date: "",
    salary: "",
    department: "",
    designation: "",
  });

  // // MARK: Use Effect Method
  useEffect(() => {
    fetchBatchesApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.teacherEditHeading
      : CommonHeadings.teacherAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const validateForm = (data) => {
    const errors = {};

    if (!data.name) {
      errors.name = ErrorMessages.name;
    }

    if (!data.selected_marital_status) {
      errors.selected_marital_status = ErrorMessages.maritalStatus;
    }
    if (!data.contact_no) {
      errors.contact_no = ErrorMessages.contactNumber;
    } else if (!/^\d*$/.test(data.contact_no)) {
      errors.contact_no = ErrorMessages.phoneNumber;
    }
    if (!data.joining_date) {
      errors.joining_date = ErrorMessages.joiningDate;
    }
    if (!data.department) {
      errors.department = ErrorMessages.department;
    }
    if (!data.designation) {
      errors.designation = ErrorMessages.designation;
    }
    if (!data.salary) {
      errors.salary = ErrorMessages.salary;
    } else if (!/^\d*$/.test(data.salary)) {
      errors.salary = ErrorMessages.salaryNumber;
    }

    return errors;
  };

  // //   when we enter any value that's set in the setTeachers() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    if (name === "dob") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    if (name === "joining_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setTeachers({
      ...teachers,
      [name]: value,
    });
  };

  // //   this function is only used for the dropdown input where users can select the category for marital status selecting into the dropdown
  const inputDropMaritalChange = (e) => {
    var { name, value } = e.target;

    setTeachers({
      ...teachers,
      [name]: value,
    });
  };

  // // MARK: fetch batches API
  async function fetchBatchesApi(e) {
    let q = query(collection(dbFirestore, TableName.batches));

    const querySnapshot = await getDocs(q);
    const a = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    //  edit functionality
    if (location.state) {
      setEditTeachersUI(a);
    }
  }

  // // MARK: edit data function
  function setEditTeachersUI(arrayBatch) {
    const birthDate = moment(location.state.dob, Dateformat.YYYYMMDD).toDate();
    setDateOfBirth(birthDate);

    const joiningDate = moment(
      location.state.joining_date,
      Dateformat.YYYYMMDD
    ).toDate();
    setJoiningdate(joiningDate);

    setTeachers((prevState) => ({
      ...prevState,
      name: location.state.name,
      dob: location.state.dob,
      selected_marital_status: location.state.selected_marital_status,
      address: location.state.address,
      contact_no: location.state.contact_no,
      whatsapp_no: location.state.whatsapp_no,
      pan_number: location.state.pan_number,
      email: location.state.email,
      joining_date: location.state.joining_date,
      salary: location.state.salary,
      father_husband_name: location.state.father_husband_name,
      father_husband_no: location.state.father_husband_no,
      account_no: location.state.account_no,
      bank_name: location.state.bank_name,
      bank_code: location.state.bank_code,
      department: location.state.department,
      designation: location.state.designation,
      account_holder_name: location.state.account_holder_name,
    }));

    setTeacherHeading(CommonHeadings.teacherEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setTeachersID(location.state.id);
  }

  // // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      ...teachers,
      created_at: createdAt,
      updated_at: null,
    };
    object.salary_num = Number(teachers.salary);
    const dobNumber = Timestamp.fromDate(new Date(object.dob)).toMillis();
    object.dob_num = dobNumber;

    const joiningDateNumber = Timestamp.fromDate(
      new Date(object.joining_date)
    ).toMillis();
    object.joining_date_num = joiningDateNumber;

    object.name = teachers.name.toLowerCase();
    object.selected_marital_status = teachers.selected_marital_status.toLowerCase();
    object.address = teachers.address.toLowerCase();
    object.email = teachers.email.toLowerCase();
    object.department = teachers.department.toLowerCase();
    object.designation = teachers.designation.toLowerCase();
    object.father_husband_name = teachers.father_husband_name.toLowerCase();
    object.bank_name = teachers.bank_name.toLowerCase();
    object.account_holder_name = teachers.account_holder_name.toLowerCase();

    return object;
  }

  // // MARK: reset values function
  function ResetValues() {
    setTeachers({
      name: "",
      dob: "",
      dob_num: "",
      selected_marital_status: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      pan_number: "",
      email: "",
      department: "",
      designation: "",
      joining_date: "",
      joining_date_num: "",
      salary: "",
      salary_num: "",
      father_husband_name: "",
      father_husband_no: "",
      account_no: "",
      bank_name: "",
      bank_code: "",
      account_holder_name: "",
    });
  }

  // // MARK: write API
  async function writeTeachersApi(edit) {
    const writePayload = payload();
    const status = "active";
    try {
      await addDoc(collection(dbFirestore, TableName.teachers), {
        ...writePayload,
        status: status,
      });

      if (edit) {
        toast.success(ToastMessages.teachersAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addTeachers);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.teachersAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.teachersList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // // MARK: update API
  async function updateTeachersApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.salary_num = Number(teachers.salary);

    try {
      await updateDoc(doc(dbFirestore, TableName.teachers, teachersID), {
        ...updatedPayload,
      });
      toast.success(ToastMessages.teachersUpdated);
      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.teachersList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(teachers);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateTeachersApi();
      } else {
        writeTeachersApi();
      }
    }
  };

  // // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(teachers);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeTeachersApi(true);
    }
  };

  // // MARK: shown input in the capital letter
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName={teacherHeading} />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row">
              <HeadingComponent
                classname="mb-1 mt-4"
                headingName="Basic Info"
              />
              <div className="col-12 col-md-6">
                <label htmlFor="name" className="input__valid">
                  Name
                </label>
                <InputText
                  name="name"
                  value={teachers.name}
                  onChange={inputChange}
                  id="name"
                  type="text"
                  placeholder="Enter your name"
                />
                {isSubmitted && (
                  <small id="name" className="p-error">
                    {errors.name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="email">Email</label>
                <InputText
                  name="email"
                  value={teachers.email}
                  onChange={inputChange}
                  id="email"
                  type="text"
                  placeholder="Enter your email"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="dob">D.O.B.</label>
                <Calendar
                  name="dob"
                  value={dateOfBirth}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
              </div>

              <div className="col-12 col-md-6">
                <label
                  htmlFor="selected_marital_status"
                  className="input__valid"
                >
                  Marital Status
                </label>
                <Dropdown
                  className="course__dropdown"
                  name="selected_marital_status"
                  value={teachers.selected_marital_status}
                  onChange={inputDropMaritalChange}
                  options={dropdownValues}
                  optionLabel="name"
                  placeholder="Select your marriage status"
                />
                {isSubmitted && (
                  <small id="selected_marital_status" className="p-error">
                    {errors.selected_marital_status}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="contact_no" className="input__valid">
                  Contact Number
                </label>
                <InputText
                  name="contact_no"
                  value={teachers.contact_no}
                  onChange={inputChange}
                  id="contact_no"
                  type="tel"
                  placeholder="Enter your contact number"
                  maxLength={10}
                />
                {isSubmitted && (
                  <small id="contact_no" className="p-error">
                    {errors.contact_no}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="whatsapp_no">Whatsapp Number</label>
              
                 <InputText
                  name="whatsapp_no"
                  value={teachers.whatsapp_no}
                  onChange={inputChange}
                  id="whatsapp_no"
                  type="tel"
                  placeholder="Enter your whatsapp number"
                  maxLength={10}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="pan_number">PAN/Aadhaar Number</label>
                <InputText
                  name="pan_number"
                  value={teachers.pan_number}
                  onChange={inputChange}
                  id="pan_number"
                  type="text"
                  placeholder="Enter your pan/aadhaar number"
                  onInput={toInputUppercase}
                />
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent classname="mb-1 mt-4" headingName="Job Info" />
              <div className="col-12 col-md-6">
                <label htmlFor="joining_date" className="input__valid">
                  Joining Date
                </label>
                <Calendar
                  name="joining_date"
                  value={joiningdate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="joining_date" className="p-error">
                    {errors.joining_date}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="salary" className="input__valid">
                  Salary
                </label>
                <InputText
                  name="salary"
                  value={teachers.salary}
                  onChange={inputChange}
                  id="salary"
                  type="text"
                  placeholder="Enter your total salary"
                />
                {isSubmitted && (
                  <small id="salary" className="p-error">
                    {errors.salary}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="department" className="input__valid">
                  Department
                </label>
                <InputText
                  name="department"
                  value={teachers.department}
                  onChange={inputChange}
                  id="department"
                  type="text"
                  placeholder="Enter your department"
                />
                {isSubmitted && (
                  <small id="department" className="p-error">
                    {errors.department}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="designation" className="input__valid">
                  Designation
                </label>
                <InputText
                  name="designation"
                  value={teachers.designation}
                  onChange={inputChange}
                  id="designation"
                  type="text"
                  placeholder="Enter designation"
                />
                {isSubmitted && (
                  <small id="designation" className="p-error">
                    {errors.designation}{" "}
                  </small>
                )}
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                classname="mb-1 mt-4"
                headingName="Other Info (Optional)"
              />
              <div className="col-12 col-md-6">
                <label htmlFor="father_husband_name">Father/Husband Name</label>
                <InputText
                  name="father_husband_name"
                  value={teachers.father_husband_name}
                  onChange={inputChange}
                  id="father_husband_name"
                  type="text"
                  placeholder="Enter your father/husband name"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="father_husband_no">
                  Father/Husband Contact No.
                </label>
               
                 <InputText
                  name="father_husband_no"
                  value={teachers.father_husband_no}
                  onChange={inputChange}
                  id="father_husband_no"
                  type="tel"
                  placeholder="Enter your father/husband  number"
                  maxLength={10}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="address">Address</label>
                <InputTextarea
                  name="address"
                  value={teachers.address}
                  onChange={inputChange}
                  id="address"
                  placeholder="Enter your address"
                  rows={3}
                  cols={30}
                />
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                classname="mb-1 mt-4"
                headingName="Bank Info(Optional)"
              />
              <div className="col-12 col-md-6">
                <label htmlFor="account_no">Account Number</label>
                <InputText
                  name="account_no"
                  value={teachers.account_no}
                  onChange={inputChange}
                  id="account_no"
                  type="tel"
                  placeholder="Enter your account number"
                  onInput={toInputUppercase}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="bank_name">Bank Name</label>
                <InputText
                  name="bank_name"
                  value={teachers.bank_name}
                  onChange={inputChange}
                  id="bank_name"
                  type="text"
                  placeholder="Enter bank name"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="bank_code">IFSC Code</label>
                <InputText
                  name="bank_code"
                  value={teachers.bank_code}
                  onChange={inputChange}
                  id="bank_code"
                  type="text"
                  placeholder="Enter bank IFSC code"
                  onInput={toInputUppercase}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="account_holder_name">Account Holder Name</label>
                <InputText
                  name="account_holder_name"
                  value={teachers.account_holder_name}
                  onChange={inputChange}
                  id="account_holder_name"
                  type="text"
                  placeholder="Enter account holder name"
                />
              </div>
            </div>
          </div>

          <BottomButtons
            loading1={loading1}
            label={buttonLabel}
            save={tapOnSave}
            loading2={loading2}
            saveNext={tapOnSaveNext}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddTeachers;
